import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import CategoryCard from '../../components/Catalog/CategoryCard';
import { useStores } from '../../hooks/use-stores';
import Loader from '../../components/Loader';
import RequestForms from '../../components/RequestForms/RequestForms';
import { Grid, Box, useTheme, useMediaQuery } from '@material-ui/core';
import PageSubTitle from '../../components/UI/PageSubTitle';

const Catalog = observer(() => {
    const theme = useTheme();
    const isMD = useMediaQuery(theme.breakpoints.down('md'));
    const { ProductStore: store } = useStores();

    useEffect(() => {
        store.getCategories();

        return () => {
            store.resetStore();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="catalog">
            <PageSubTitle>категории</PageSubTitle>

            {store.loading && <Loader />}

            {!store.loading && (
                <Box mb={{ xxs: 6, lg: 9 }}>
                    <Grid container spacing={isMD ? 3 : 5}>
                        {store.categories
                            .filter(item => item.id !== '25')
                            .map(item => (
                                <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                                    <CategoryCard data={item} />
                                </Grid>
                            ))}
                    </Grid>
                </Box>
            )}

            <RequestForms />
        </div>
    );
});

export default Catalog;
